<template>
  <div class="text-center mt-5">
    <h1 class="h1">404: Page not found</h1>
  </div>
</template>